import { createTheme } from "@material-ui/core/styles";
import { fontFamilies } from "common/constants";

const theme = createTheme({
  typography: {
    fontFamily: "Core Sans C, sans-serif",
    h3: {
      fontFamily: fontFamilies[300],
      fontWeight: 300,
      margin: "5px 0 0",
      fontSize: 40,
      lineHeight: "52px",
    },
    h4: {
      margin: "20px 0",
    },
  },
  palette: {
    primary: {
      main: "#8214DC",
    },
    secondary: {
      main: "#FCFF00",
    },
    error: {
      main: "#F44336",
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": {
          fontFamily: "Core Sans C",
          fontStyle: "normal",
          fontDisplay: "swap",
          fontWeight: 300,
          src: `local("Core Sans C 35 Light"), local("CoreSansC-35Light"), url(${require("../assets/fonts/CoreSansC/CoreSansC-35Light.ttf")}) format('ttf')`,
          unicodeRange:
            "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
        },
      },
    },
    MuiPopover: {
      paper: {
        minHeight: 0,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 16,
      },
      paperWidthSm: {
        maxWidth: 800,
      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
      root: {
        borderTop: "none",
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "none",
        border: "1px solid rgba(75, 100, 255, 0.1)",
        borderRadius: 12,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid rgba(75, 100, 255, 0.1)",
      },
      stickyHeader: {
        textTransform: "capitalize",
      },
    },
    MuiTab: {
      root: {
        minWidth: 0,
        "@media (min-width: 0px)": {
          minWidth: 0,
        },
      },
    },
    MuiTableRow: {
      root: {
        "&$selected": {
          backgroundColor: "rgba(75, 100, 255, 0.05)",
        },
      },
      hover: {
        "&:hover": {
          backgroundColor: "rgba(75, 100, 255, 0.05) !important",
        },
        "&:hover svg": {
          visibility: "visible",
        },
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 40,
        ".Mui-selected > &": {
          filter: "invert(1)",
        },
        color: "#fff",
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "rgba(75, 100, 255, 0.1)",
      },
    },
    MuiIconButton: {
      root: {
        padding: 10,
        "&:hover": {
          backgroundColor: "#EDEFFF",
        },
      },
      sizeSmall: {
        padding: 5,
      },
    },
  },
});

export default theme;
